import { Config } from "../config/Config";
import { FieldValue, firestore } from "../utilities/Firebase";

type QuestionnaireAnswer = {
  qId: string,
  answers: number[]
}

/**
 * スタンプカードサービス
 */
export const StampCardService = () => {
  /**
   * Firestore からスタンプカードデータを取得する
   * @param userId ユーザーID
   * @param campaignId キャンペーンID
   * @returns スタンプカードデータ
   */
  const getStampCard = async (userId: string, campaignId: string) => {
    const doc = await firestore.collection(Config.appEnv!)
      .doc(campaignId)
      .collection("StampCards")
      .doc(userId).get();
    return { id: doc.id, data: doc.data() };
  };

  /**
   * スタンプカードをエントリー状態に更新する
   * @param stampCardId スタンプカードID
   * @param campaignFrom キャンペーン開始日
   * @param campaignTo キャンペーン終了日
   * @returns 更新結果 (ok: 更新成功 | preparing: キャンペーン開始前 | end: キャンペーン終了後)
   */
  const entry = async (campaignId: string, stampCardId: string, campaignFrom: Date, campaignTo: Date) => {
    // isEntryをtrueに更新
    const docRef = firestore.collection(Config.appEnv!)
      .doc(campaignId)
      .collection("StampCards")
      .doc(stampCardId);
    await docRef.update({ isEntry: true, entryTime: FieldValue.serverTimestamp() });
    // 更新後のドキュメントを取得
    const doc = await docRef.get();
    // エントリー日時を取得
    const entryTIme = doc.data()?.entryTime.toDate();

    if (entryTIme < campaignFrom || campaignTo < entryTIme) {
      // エントリー日時がキャンペーン期間外の場合、エントリー状態を差し戻す
      await docRef.update({ isEntry: false, entryTime: null });
      return entryTIme < campaignFrom ? "preparing" : "end";
    }

    return "ok";
  };

  /**
   * アンケートの回答を登録する
   * @param answers アンケートの回答
   */
  const setAnswers = async (campaignId: string, stampCardId: string, answers: QuestionnaireAnswer[]) => {
    const docRef = firestore.collection(Config.appEnv!)
      .doc(campaignId)
      .collection("StampCards")
      .doc(stampCardId);
    await docRef.update({ questionnaireAnswers: answers });
  }

  return { getStampCard, entry, setAnswers }
}
